import { useEffect, useState } from "react";
import { useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import styles from "./TodayRequestList.module.css";
import axios from "axios";
import Loader from "../components/Loader";
import { authData } from "../components/GetAuth";
import { Checkbox, FormControlLabel, FormControl, InputLabel, MenuItem, Select, TextField, Alert, Snackbar, Button } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { NumericFormat } from "react-number-format";
import { useForm, Controller, useFieldArray } from "react-hook-form";

const DriverItemEdit = () => {
  const bookingId = useParams();
  const auth = authData();
  const navigate = useNavigate();
  const API_TOKEN = auth?.api_token;
  const [bookingData, setBookingData] = useState({});
  const [productList, setProductList] = useState([]);
  const [itemTotal, setItemTotal] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");

  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, control, setValue, getValues, formState: { errors }, clearErrors, watch } = useForm({
    mode: "onChange",
    defaultValues: {
      products: bookingData?.products ? bookingData?.products : [{ category_id: "", item_id: "", item_name: "", total: "", is_fragile: false, is_item: true, }]
    }
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "products",
  });

  useEffect(() => {
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/driver/booking-item-details/" + bookingId?.id, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setLoading(false);
        let bookingDataTemp = response.data.data;
        let products = bookingDataTemp?.products?.map((i) => {
          let isFragile = i?.is_fragile === 1 ? true : false;
          let categoryId = i?.parent_id > 0 ? i?.parent_id : i?.product_id;
          let isItem = i?.parent_id > 0 ? true : false;
          return { category_id: categoryId, is_fragile: isFragile, is_item: isItem, item_id: i?.product_id, item_name: i?.product_title, total: i?.sub_amount };
        });
        setBookingData((prev) => {
          return { ...prev, customer_id: bookingDataTemp?.customer_id, products: products };
        });

        if (response?.data?.data) {
          if (response?.data?.data?.products) {
            replace(response?.data?.data?.products);
          }
        }
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }, [API_TOKEN, bookingId, setValue, replace]);

  useEffect(() => {
    if (bookingData) {
      setValue(`customer_id`, bookingData?.customer_id);

      if (bookingData?.products) {
        let itemT = 0;
        bookingData?.products.forEach((i) => {
          if (i?.total !== "") {
            itemT += parseFloat(i?.total);
          }
        });
        setItemTotal(itemT);

        replace(bookingData?.products);
      }
    }
  }, [bookingData, setValue, replace]);

  useEffect(() => {
    axios.get(process.env.REACT_APP_API_URL + "v1/driver/product-dd-list", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setProductList(response.data.data);
      }
    });
  }, [API_TOKEN]);

  const cngProductVal = () => {
    let products = getValues("products");
    let itemT = 0;
    products.forEach((i) => {
      if (i?.total !== "") {
        itemT += parseFloat(i?.total);
      }
    });
    setItemTotal(itemT);
  };

  const onSubmit = (data) => {
    let noOfItems = 0;
    let subTotal = 0;
    let products = data.products.map((item) => {
      noOfItems += 1;
      subTotal += parseFloat(item.total);
      return { product_id: item?.item_id, product_title: item?.item_name, price: item?.total, quantity: 1, sub_amount: item.total, is_fragile: item?.is_fragile ? 1 : 0 };
    });

    let postData = { customer_id: bookingId?.customer_id, booking_id: bookingId?.id, no_of_items: noOfItems, total: subTotal, amount: subTotal, products: products };

    axios.post(process.env.REACT_APP_API_URL + "v1/driver/update-items", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");

        setTimeout(() => {
          navigate("/driver/payment-details/" + bookingId?.id);
        }, 2000);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  return (<>
    <div className={`${styles.MainDiv}`}>
      <Loader open={loading} setOpen={setLoading.bind(this)} />
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Item Edit</p>
      </div>
      <div className={`${styles.MainCard}`}>
        <div className={`${styles.StepOneForm}`}>
          <form id="step2-form" onSubmit={handleSubmit(onSubmit)}>
            <div className={`${styles.StepOneFormRow}`}>
              <div className={`${styles.StepOneFormBig}`}>
                <div className={`${styles.BookADelivery}`}>
                  <div className={`${styles.BookADeliveryCardArea}`}>
                    {fields.map((item, index) => {
                      return (<div className={`${styles.BookDeliveryCard}`} key={item.id} style={{ background: "#D1E7FC" }}>
                        <div className={`${styles.BookDeliveryCardUnder}`}>
                          <div className={`${styles.BookDeliveryCardUnderRow}`}>
                            <div className={`${styles.BookDeliveryFormCard25}`}>
                              <div className={`FormHalfGroup`}>
                                <FormControl fullWidth>
                                  <InputLabel>Category*</InputLabel>
                                  <Controller
                                    key={item.id}
                                    control={control}
                                    {...register(`products[${index}].category_id`, { required: true })}
                                    render={({ field }) => (<Select
                                      {...field}
                                      label="Category*"
                                      onChange={(e) => {
                                        field.onChange(e);
                                        if (e.target.value) {
                                          let selCat = productList?.filter((i) => i?.id === e.target.value);
                                          if (selCat.length) {
                                            selCat = selCat[0];
                                            if (selCat?.no_of_child === 0) {
                                              setValue(`products[${index}].item_id`, selCat?.id);
                                              setValue(`products[${index}].item_name`, selCat?.title);
                                              setValue(`products[${index}].total`, selCat?.amount);
                                              setValue(`products[${index}].is_fragile`, selCat?.is_fragile === 1);
                                              setValue(`products[${index}].is_item`, false);
                                            } else {
                                              setValue(`products[${index}].item_id`, "");
                                              setValue(`products[${index}].product_title`, "");
                                              setValue(`products[${index}].total`, "");
                                              setValue(`products[${index}].is_fragile`, false);
                                              setValue(`products[${index}].is_item`, true);
                                            }
                                            clearErrors();
                                          }
                                          cngProductVal();
                                        }
                                      }}
                                    >
                                      {productList?.map((val) => {
                                        return val?.parent_id === 0 ? (<MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>) : null;
                                      })}
                                    </Select>)}
                                  />
                                </FormControl>
                                {errors?.products?.length > 0 && errors?.products[index]?.category_id && (<p className={`${styles.ErrorM}`}>Please select category</p>)}
                              </div>
                            </div>

                            <div className={`${styles.BookDeliveryFormCard25}`}>
                              {watch(`products[${index}].is_item`) && (<div className={`FormHalfGroup`}>
                                <FormControl fullWidth>
                                  <InputLabel>Item*</InputLabel>
                                  <Controller
                                    key={item.id}
                                    control={control}
                                    {...register(`products[${index}].item_id`, { required: true })}
                                    render={({ field }) => (<Select
                                      {...field}
                                      label="Item*"
                                      onChange={(e) => {
                                        field.onChange(e);
                                        if (e.target.value) {
                                          let selProduct = productList?.filter((i) => i?.id === e.target.value);
                                          if (selProduct.length) {
                                            selProduct = selProduct[0];
                                            setValue(`products[${index}].item_name`, selProduct?.parent?.title + "- " + selProduct?.title);
                                            setValue(`products[${index}].total`, selProduct?.amount);
                                            setValue(`products[${index}].is_fragile`, selProduct?.is_fragile === 1);
                                            clearErrors();
                                          }
                                        }
                                        cngProductVal();
                                      }}
                                    >
                                      {productList?.map((val) => {
                                        return val?.parent_id === watch(`products[${index}].category_id`) ? (<MenuItem key={val?.id} value={val?.id}>{val?.title}</MenuItem>) : null;
                                      })}
                                    </Select>
                                    )}
                                  />
                                </FormControl>
                                {errors?.products?.length > 0 && errors?.products[index]?.item_id && (<p className={`${styles.ErrorM}`}>Please select item</p>)}
                              </div>)}
                            </div>

                            <div className={`${styles.BookDeliveryFormCard10}`}>
                              <div className={`${styles.FormField}`}>
                                <FormControlLabel
                                  label="Fragile?"
                                  className={`${styles.CheckBox} CheckBox`}
                                  control={
                                    <Controller
                                      key={item.id}
                                      control={control}
                                      {...register(`products[${index}].is_fragile`)}
                                      render={({ field }) => (<Checkbox {...field} checked={field?.value} />)}
                                    />
                                  }
                                />
                              </div>
                            </div>

                            <div className={`${styles.BookDeliveryFormCard20}`}>
                              <div className={`${styles.FormField}`}>
                                <Controller
                                  key={item.id}
                                  control={control}
                                  {...register(`products[${index}].total`, { required: true })}
                                  render={({ field }) => (<NumericFormat
                                    {...field}
                                    label="Total*"
                                    variant="outlined"
                                    customInput={TextField}
                                    allowLeadingZeros={false}
                                    allowNegative={false}
                                    decimalScale={2}
                                    fixedDecimalScale
                                    onChange={(e) => {
                                      field.onChange(e);
                                      cngProductVal();
                                    }}
                                  />)}
                                />
                                {errors?.products?.length > 0 && errors?.products[index]?.total && (<p className={`${styles.ErrorM}`}>Please enter total amount</p>)}
                              </div>
                            </div>
                          </div>
                        </div>

                        <button className={`${styles.CardTrashBU}`} type="button" onClick={(e) => { if (fields.length <= 1) return false; remove(index); }}><Delete /></button>
                      </div>);
                    })}

                    <button className={`${styles.HomeBU}`} type="button" onClick={() => { append({ category_id: "", item_id: "", item_name: "", total: "", is_fragile: false, is_item: true }); }}>Add Items</button>
                  </div>
                </div>
              </div>
              <div className={`${styles.StepBUSec}`} style={{ textAlign: "right" }}>
                <p className={`${styles.UserProDeList}`}>
                  <span>Total Amount:</span>
                  <span>&pound; {parseFloat(itemTotal).toFixed(2)}</span>
                </p>
              </div>

              <div className={`${styles.StepBUSec}`}>
                <RouterLink as={Button} to={`/driver/item-details/${bookingId?.id}`} className={`CancelBU`}>Cancel</RouterLink>
                <Button className={`SubmitBU`} type="submit">Save</Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>
  );
}

export default DriverItemEdit;